/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_kpi_publishers13 = /** @type {(inputs: {}) => string} */ () => {
	return `Publishers`
};

const fr_kpi_publishers13 = /** @type {(inputs: {}) => string} */ () => {
	return `Créateurs`
};

const de_kpi_publishers13 = /** @type {(inputs: {}) => string} */ () => {
	return `Verlag`
};

const es_kpi_publishers13 = /** @type {(inputs: {}) => string} */ () => {
	return `Editores`
};

const it_kpi_publishers13 = /** @type {(inputs: {}) => string} */ () => {
	return `Editori`
};

const ar_kpi_publishers13 = /** @type {(inputs: {}) => string} */ () => {
	return `الناشرون`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const kpi_publishers13 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.kpi_publishers13(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("kpi_publishers13", locale)
	if (locale === "en") return en_kpi_publishers13(inputs)
	if (locale === "fr") return fr_kpi_publishers13(inputs)
	if (locale === "de") return de_kpi_publishers13(inputs)
	if (locale === "es") return es_kpi_publishers13(inputs)
	if (locale === "it") return it_kpi_publishers13(inputs)
	return ar_kpi_publishers13(inputs)
};
export { kpi_publishers13 as "KPI_PUBLISHERS" }